import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'Accueil' }
  },
  {
    path: '/article/:id',
    name: 'Article',
    component: () => import('../views/Article.vue'),
    meta: { title: 'Article' }
  },
  {
    path: '/:tag1?/:tag2?/:slug',
    name: 'ArticleBySlug',
    component: () => import('../views/Article.vue'),
    meta: { title: 'Article' }
  },
  {
    path: '/source/:id',
    name: 'Source',
    component: () => import('../views/Source.vue'),
    meta: { title: 'Source' }
  },
  {
    path: '/category/:id',
    name: 'Category',
    component: () => import('../views/Category.vue'),
    meta: { title: 'Catégorie' }
  },
  {
    path: '/mes-sources',
    name: 'MySources',
    component: () => import('../views/MySources.vue'),
    meta: { requiresAuth: true, title: 'Mes Sources' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: { requiresAuth: true, title: 'Mon Profil' }
  },
  {
    path: '/inscription',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    meta: { guestOnly: true, title: 'Inscription' }
  },
  {
    path: '/connexion',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { guestOnly: true, title: 'Connexion' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: { title: 'Page introuvable' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Navigation Guards
router.beforeEach((to, from, next) => {
  // Mettre à jour le titre de la page
  document.title = `${to.meta.title || to.name} - LesActualites.fr`
  
  // Vérifier si l'utilisateur est authentifié pour les routes protégées
  const isAuthenticated = store.getters['auth/isAuthenticated']
  
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else if (to.matched.some(record => record.meta.guestOnly) && isAuthenticated) {
    next({ name: 'Home' })
  } else {
    next()
  }
})

export default router